import { Component, HostListener, OnInit, SimpleChanges } from '@angular/core';
import { map, Observable, Subscription, tap } from 'rxjs';
import { Entity } from 'src/app/core/models/entity.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { Team } from 'src/app/core/models/team.model';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { EntityService } from 'src/app/core/services/entity.service';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import * as utils from 'src/app/shared/helpers/utils';


@Component({
  selector: 'hbo-entity-list',
  templateUrl: './entity-list.component.html',
  styleUrls: ['./entity-list.component.scss']
})
export class EntityListComponent implements OnInit {

  @HostListener('document:shown.bs.collapse', ['$event'])
  onAccordionOpen(event: any) {
    this.openedRow = event.target!.id;
  }

  @HostListener('document:hide.bs.collapse', ['$event'])
  onAccordionClosed(event: Event) {
    this.openedRow = null;
  }

  entities$ = new Observable<Pagination<Entity>>;
  entitiesCollection$: Entity[] = [];

  user: User = utils?.localStorageGetItem('user');

  openedRow!: string | null;

  columns: string[] = [];


  constructor(
    private configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    private entityService: EntityService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    switch (this.user.roleId) {
      case 1:
        this.columns = ['id', 'name', 'entityType', 'identityCode', 'located', 'contact', 'horizonsTeam', 'team'];
        break;
      case 2:
        this.columns = ['id', 'name', 'entityType', 'identityCode', 'located', 'contact', 'team'];
        break;
      default:
        this.columns = ['id', 'name', 'entityType', 'identityCode', 'located', 'contact'];
        break;
    }
  }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  ngOnInit() {
    //this.ddbbUtils.getEntityChilds(this.user.entityId).then(result => {
    /*this.user.childEntities = result;
    utils.localStorageSetItem('user', this.user);*/
    const storageEntitiesFilter = localStorage.getItem('entitiesListFilter');
    if (storageEntitiesFilter) {
      this.searchEntities(JSON.parse(storageEntitiesFilter));
    } else {
      this.searchEntities();
    }
    //});
  }



  searchEntities(pagination?: PaginationRequest) {
    this.openedRow = null;
    let entities: string | null = null;
    if (this.configSvc.currentConfigValue.entitiesListSelected?.length) {
      entities = `${this.configSvc.currentConfigValue.entitiesListSelected?.map((entity: Entity) => entity.id).join(',')}`;
    }
    if (pagination) pagination!.entities = entities;
    this.entities$ = this.entityService.index(pagination ?? { order: 'desc', entities: entities }).pipe(
      tap(result => {
        this.entitiesCollection$ = result.data.map(entity => ({
          ...entity,
          calculatedTeamName: this.calculateTeamName(entity)
        }));
    }));
  }

  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        const propsToRemove = ['name', 'parentEntityId', 'contact', 'identityCode'];
        this.entitiesCollection$.map((entity: Entity) => {
          if (entity.id === e.result.id) {
            this.deepMerge(entity, e.result);
            (e as any).calculatedTeamName = this.calculateTeamName(e);
          };
        })
        break;
      default:
        break;
    }
  }

  private calculateTeamName(_entity: Entity): string | null {
    switch (_entity.entityTypeId) {
      case 3:
      case 4:
        return this.configSvc.currentConfigValue.teams?.find((team: Team) => team.id === _entity.teamId)?.name!
      default:
        return '-'
    }
  }

  deepMerge = (target: any, source: any) => {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        if (!target[key] || typeof target[key] !== 'object') {
          target[key] = {};
        }
        this.deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }

}
